import { browserHistory } from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/broadcast';

const Broadcast = {

  getBroadcasts( params ) {
    return axios
      .get( baseEndpoint, { params } )
  },

  formatFormDataBody( data ) {
    const formData = new FormData();

    _.forEach( data, ( value, key ) => {
      if( value ) formData.append( key, value );
    } );

    return formData;
  },

  sendBroadcast( data ) {
    return axios
      .post( baseEndpoint, this.formatFormDataBody( data ) )
  },
};

export default Broadcast;



// WEBPACK FOOTER //
// ./services/BroadcastService.js